// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReusableDropdownComp
  :where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown
  .ant-dropdown-menu
  .ant-dropdown-menu-item:hover,
:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown-menu-submenu
  .ant-dropdown-menu
  .ant-dropdown-menu-item:hover,
:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown
  .ant-dropdown-menu
  .ant-dropdown-menu-submenu-title:hover,
:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown-menu-submenu
  .ant-dropdown-menu
  .ant-dropdown-menu-submenu-title:hover,
:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown
  .ant-dropdown-menu
  .ant-dropdown-menu-item-active,
:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown-menu-submenu
  .ant-dropdown-menu
  .ant-dropdown-menu-item-active,
:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown
  .ant-dropdown-menu
  .ant-dropdown-menu-submenu-title-active,
:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown-menu-submenu
  .ant-dropdown-menu
  .ant-dropdown-menu-submenu-title-active {
  background-color: transparent !important;
}
`, "",{"version":3,"sources":["webpack://./src/commons/Dropdowns/ReusableDropdownComp.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE,wCAAwC;AAC1C","sourcesContent":[".ReusableDropdownComp\n  :where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown\n  .ant-dropdown-menu\n  .ant-dropdown-menu-item:hover,\n:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown-menu-submenu\n  .ant-dropdown-menu\n  .ant-dropdown-menu-item:hover,\n:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown\n  .ant-dropdown-menu\n  .ant-dropdown-menu-submenu-title:hover,\n:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown-menu-submenu\n  .ant-dropdown-menu\n  .ant-dropdown-menu-submenu-title:hover,\n:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown\n  .ant-dropdown-menu\n  .ant-dropdown-menu-item-active,\n:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown-menu-submenu\n  .ant-dropdown-menu\n  .ant-dropdown-menu-item-active,\n:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown\n  .ant-dropdown-menu\n  .ant-dropdown-menu-submenu-title-active,\n:where(.css-dev-only-do-not-override-1k6v9fd).ant-dropdown-menu-submenu\n  .ant-dropdown-menu\n  .ant-dropdown-menu-submenu-title-active {\n  background-color: transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
